import { Icon, SOURCE_ICON } from '../icons';

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  captured: { label: 'Captured', className: 'badge-captured' },
  exploring: { label: 'Exploring', className: 'badge-exploring' },
  building: { label: 'Building', className: 'badge-building' },
  shipped: { label: 'Shipped', className: 'badge-shipped' },
  shelved: { label: 'Shelved', className: 'badge-shelved' },
};


/** Status is a dot plus the word (tokens rule 4), never a filled pill. */
export function StatusBadge({ status }: { status: string }) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: '' };
  return (
    <span className={`status-word ${config.className}`}>
      <span className="status-word-dot" style={{ background: `var(--nr-status-${status}, var(--nr-text-mute))` }} aria-hidden="true" />
      {config.label}
    </span>
  );
}

export function SourceIcon({ source }: { source: string }) {
  return (
    <span className="source-icon" title={source}>
      <Icon name={SOURCE_ICON[source] ?? 'web'} size={14} />
    </span>
  );
}

export function TagChip({
  name,
  color,
  active,
  onClick,
}: {
  name: string;
  color?: string | null;
  active?: boolean;
  onClick?: () => void;
}) {
  return (
    <span
      className={`tag-chip${active ? ' tag-chip-active' : ''}${onClick ? ' tag-chip-clickable' : ''}`}
      style={color ? { borderColor: color, color: active ? '#fff' : color, background: active ? color : undefined } : undefined}
      onClick={onClick}
    >
      {name}
    </span>
  );
}
